if (!customElements.get('card-product')) {
  customElements.define(
    'card-product',
    class CardProduct extends HTMLElement {
      get planId() {
        return this.getAttribute('data-plan-id');
      }

      get planSelectorInput() {
        return this.querySelector(`input[name="PurchasePlanSelector-${this.planId}"]`);
      }

      get productFormPlanInput() {
        return this.querySelector(`product-form input[name="selling_plan"]`);
      }

      constructor() {
        super();
        this.changeEvent = this.handleChangeEvent.bind(this);
      }

      connectedCallback() {
        if (!this.planSelectorInput || !this.productFormPlanInput) return;
        this.updatePurchasePlan();
        this.addEventListener('change', this.changeEvent);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeEvent);
      }

      handleChangeEvent(event) {
        if (!this.planSelectorInput.contains(event.target)) return;
        this.updatePurchasePlan();
      }

      updatePurchasePlan() {
        this.planSelectorInput.checked ? 
          this.toggleAttribute(this.productFormPlanInput, 'disabled', true) : 
          this.toggleAttribute(this.productFormPlanInput, 'disabled', false);
      }

      toggleAttribute(el, attribute, toggle) {
        if (!el) return;
        toggle ? 
          el.hasAttribute(attribute) && el.removeAttribute(attribute) : 
          !el.hasAttribute(attribute) && el.setAttribute(attribute, '');
      }
    }
  )
}